import React, { useState, useEffect, Fragment } from "react";
import "./_login.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import modalClose from "../../Assets/Images/close.svg";
import LoginForm from "./LoginForm";

export default function BookDemo(props) {
  return (
    <Fragment>
      <Modal
        show={props.showModal}
        onHide={props.handleCloseModal}
        // size="md"
        className="login-modal">
        <div className="position-relative">
          <a onClick={props.handleCloseModal} className="close">
          <img src={modalClose} alt="close" />
          </a>
        </div>
        <Modal.Body>
          <div className="login-container gap-4">
           
            <div className="input-form col-lg-10 m-auto">
              <div className="text-center">
                <h4 className="login-heading  roboto-bold">
                INTERESTED? <br />
                    TALK TO AN EXPERT
                  </h4>
              </div>
               <LoginForm/>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}
